var map = {
	"./a-simple-introduction.md": [
		7989,
		989
	],
	"./our-work-not-ours.md": [
		9162,
		162
	],
	"./template1.md": [
		3247,
		247
	],
	"./template2.md": [
		6358,
		358
	],
	"./template3.md": [
		3749,
		749
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2994;
module.exports = webpackAsyncContext;